import React from "react"
import ReportToolsIconButton from "./ReportToolsIconButton"

const ReportToolsPdfIconButton = ({ title = "Download PDF", size = "small", ...props }) => (
  <ReportToolsIconButton title={title} size={size} icon="pdf" {...props} />
)

export default ReportToolsPdfIconButton
